import { reportCurrency } from './reportMoney.js';
/** Presentation only. Keep historical denominations and omit zero tile rows. */
export function earningsPresentation(items, current) {
    const currencies = [...new Set(current.map(reportCurrency).filter((c) => !!c))];
    const nonzero = items.filter((i) => i.cents !== 0);
    return {
        current: nonzero.filter((i) => !!i.currency && currencies.includes(i.currency)),
        historical: nonzero.filter((i) => !i.currency || !currencies.includes(i.currency)),
        currencies,
    };
}
const storedNumber = (v) => typeof v === 'number' && Number.isFinite(v) && v >= 0 ? v : null;
/** Reads only pins and server evidence. Untyped hourly charges are never labelled idle. */
export function idleSummaryFacts(s) {
    const policy = s.idle_policy_at_start;
    if ((policy?.rate_type ?? s.tariff_rate_type_at_start) === 'per_hour')
        return null;
    const rate = storedNumber(policy?.rate_cents ?? s.idle_view?.rate_cents ?? s.idle_rate_at_start_cents);
    const amount = storedNumber(s.idle_report?.idle_fee_cents ??
        s.idle_view?.idle_cents ??
        s.idle_tracking?.idle_cents ??
        (rate && rate > 0 ? s.cost?.time_cost : null));
    if (amount == null || !(amount > 0 || (rate != null && rate > 0)))
        return null;
    return {
        amount_cents: amount,
        currency: reportCurrency(s.idle_report?.currency ?? s.idle_view?.currency ?? s.cost?.currency),
        billed_minutes: storedNumber(s.idle_report?.billed_idle_minutes ??
            s.idle_view?.billable_minutes ??
            s.idle_tracking?.billable_minutes),
        rate_cents: rate,
        grace_minutes: storedNumber(policy?.grace_minutes ??
            s.idle_report?.idle_grace_minutes ??
            s.idle_view?.grace_minutes ??
            s.idle_grace_at_start_minutes),
    };
}
export function payoutCashDiffers(ledger, cash) {
    return (!!cash?.length &&
        (cash.length !== 1 ||
            cash[0].currency !== ledger.currency ||
            cash[0].amount_cents !== ledger.cents));
}
//# sourceMappingURL=hostDisplay.js.map